import { useMemo, useState } from "react";
import { useQuery } from "@apollo/client/react";

import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import useErrorHandle from "hooks/useErrorHandle";

import useFilters from "./useFilters";
import UsageRunMinutesContent from "./Content";
import { GET_RUN_MINUTES_USAGE } from "./gql";
import { getRunMinutesUsageWindow, normalizeRunMinutesUsage } from "./utils";

const UsageRunMinutes = () => {
  const { groupBy, setGroupBy } = useFilters();

  const [usageWindow] = useState(getRunMinutesUsageWindow);

  const { loading, data, error } = useQuery(GET_RUN_MINUTES_USAGE, {
    variables: { input: usageWindow },
  });

  const usage = useMemo(
    () => (data?.runMinutesUsage ? normalizeRunMinutesUsage(data.runMinutesUsage) : undefined),
    [data]
  );

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loading && !usage) {
    return <PageLoading />;
  }

  if (!usage) {
    return <NotFoundPage />;
  }

  return <UsageRunMinutesContent usage={usage} groupBy={groupBy} onGroupByChange={setGroupBy} />;
};

export default UsageRunMinutes;
